import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";

import ProtectedRoute from "./pages/components/ProtectedRoute";

import SubAdminDashboard from "./pages/sub_admin/SubAdminDashboard";
import CentralAdminDashboard from "./pages/central_admin/CentralAdminDashboard";
import EmployeeDashboard from "./pages/emplyee_portal/EmployeeDashboard";
import EmployeeTeamSubmissions from "./pages/emplyee_portal/TeamSubmissions";

// ================= Vendor =================
import UserVendorManagement from "./pages/emplyee_portal/UserVendorManagement";
import AddVendor from "./pages/emplyee_portal/AddVendor";
import VendorView from "./pages/emplyee_portal/VendorView";
import DocViewer from "./pages/emplyee_portal/DocViewer";
import EditVendor from "./pages/emplyee_portal/EditVendor";

// ================= Client =================
import ClientList from "./pages/emplyee_portal/ClientList";
import AddClient from "./pages/emplyee_portal/AddClient";
import UpdateClient from "./pages/emplyee_portal/UpdateClient";
import EmployeeViewClient from "./pages/emplyee_portal/ClientView";
// ================= Candidate =================
import AddCandidate from "./pages/emplyee_portal/AddCandidate";
import CandidateList from "./pages/emplyee_portal/CandidateList";
import ViewCandidate from "./pages/emplyee_portal/ViewCandidate";
import UpdateCandidate from "./pages/emplyee_portal/UpdateCandidate";
import UserCandidatelist from "./pages/emplyee_portal/UserCandidateList";
import SubmittedProfiles from "./pages/emplyee_portal/SubmittedProfiles";

// ================= Pool =================
import PoolSelect from "./pages/emplyee_portal/Pool";
import VendorManagement from "./pages/emplyee_portal/VendorManagement";

// ===================Sub-Admin============================
import AllCandidateList from "./pages/sub_admin/allCandidateList";
import AllVendorList from "./pages/sub_admin/AllVendorList";
import SubAdminAddVendor from "./pages/sub_admin/subadminAddVendor";
import EditVendorSubAdmin from "./pages/sub_admin/EditVendor";
import SubAdminAddCandidate from "./pages/sub_admin/SubAdminAddCandidate";
import SubAdminViewCandidate from "./pages/sub_admin/SubAdminViewCandidate";
import SubAdminEditCandidate from "./pages/sub_admin/SubAdminEditCandidate";
import VendorViewSubAdmin from "./pages/sub_admin/VendorView";
import SubAdminClientList from "./pages/sub_admin/ClientList";
import ViewClient from "./pages/sub_admin/ViewClient";
import SubAdminAddClient from "./pages/sub_admin/AddClient";
import SubAdminDocView from "./pages/sub_admin/DocViewer";
import SubAdminTeamManage from "./pages/sub_admin/TeamManage";
import AddUser from "./pages/sub_admin/AddUser";
import SubAdminUserDetail from "./pages/sub_admin/SubAdminUserDetail";
import SubAdminUserUpdate from "./pages/sub_admin/SubAdminUserUpdate";

import SubAdminClientView from "./pages/sub_admin/ClientView";
import SubadminTotalSubmittedProfiles from "./pages/sub_admin/TotalSubmittedProfiles";
import SubadminTotalOnbording from "./pages/sub_admin/TotalOnbording";
import SubadminTodaysSubmittedProfiles from "./pages/sub_admin/TodaysSubmittedProfiles";
import SubadminTodaysNewProfiles from "./pages/sub_admin/TodaysNewProfiles";
import SubadminPipeline from "./pages/sub_admin/Pipeline";
import OffboardedProfiles from "./pages/sub_admin/OffboardedProfiles";

// -------Invoice---
import SubadminCreateInvoice from "./pages/sub_admin/invoice/CreateInvoice";
import SubadminInvoicePreview from "./pages/sub_admin/invoice/InvoicePreview";
import SubadminInvoices from "./pages/sub_admin/invoice/InvoiceList";
import SubadminSettings from "./pages/sub_admin/invoice/CompanySettingsView";
import SubadminSettingsEdit from "./pages/sub_admin/invoice/CompanySettingsEdit";
import SubadminEditInvoice from "./pages/sub_admin/invoice/EditInvoice";
import CandidateInvoiceHistory from "./pages/sub_admin/invoice/CandidateHistory";
import SubadminUpdateClient from "./pages/sub_admin/Updateclient";

// ========================================================

import AccountsDashboard from "./pages/Accounts/AccountsDashboard";
import FinanceSettings from "./pages/Accounts/FinanceSettingsPage";
import FinanceList from "./pages/Accounts/FinanceListView";
import CreateInvoice from "./pages/Accounts/CreateInvoicePage";
import AllInvoices from "./pages/Accounts/InvoiceListPage"
import EditInvoice from "./pages/Accounts/Editinvoicepage";
// ========================================================


// ========= Requirements ===============
import RequirementList from "./pages/emplyee_portal/Requirement/RequirementsList";
import RequirementCreate from "./pages/emplyee_portal/Requirement/RequirementCreate";
import RequirementUpdate from "./pages/emplyee_portal/Requirement/RequirementUpdate";
import RequirementView from "./pages/emplyee_portal/Requirement/RequirementView";
import EmpMyRequirements from "./pages/emplyee_portal/Requirement/MyRequirements";
// Sub-admin Requirement List
import SubAdminRequirementList from "./pages/sub_admin/Requirement/SubRequirementsList";
import SubAdminRequirementCreate from "./pages/sub_admin/Requirement/SubRequirementCreate";
import SubAdminRequirementUpdate from "./pages/sub_admin/Requirement/SubRequirementUpdate";
import SubAdminRequirementView from "./pages/sub_admin/Requirement/SubRequirementView";   
import SubAdminMyRequirements from "./pages/sub_admin/Requirement/SubMyRequirements";      

// ========AttedanceDashboard============EMPLOYEE=====
import AttendanceDashboard from "./pages/emplyee_portal/Attendance/Attendancedashboard";
import AttendanceBoard     from "./pages/emplyee_portal/Attendance/Attendanceboard";
import MyMonthly           from "./pages/emplyee_portal/Attendance/Mymonthly";

// ===============AttedanceDashboard=====SUBADMIN======
import TeamReports from "./pages/sub_admin/Attendance/TeamReports";

function App() {
    return (
        <BrowserRouter>
            <Routes>

                {/* Public Routes */}
                <Route path="/" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* Protected Routes */}
                <Route path="/employee" element={ <ProtectedRoute> <EmployeeDashboard /> </ProtectedRoute> } />
                <Route path="/employee/TeamSubmissions" element={<ProtectedRoute><EmployeeTeamSubmissions /></ProtectedRoute>} />
                
                
                <Route path="/employee/candidates/add" element={<ProtectedRoute><AddCandidate /></ProtectedRoute>} />
                <Route path="/employee/candidates" element={<ProtectedRoute><CandidateList /></ProtectedRoute>} />
                <Route path="/employee/candidate/view/:id" element={<ProtectedRoute><ViewCandidate /></ProtectedRoute>} />
                <Route path="/employee/candidate/edit/:id" element={<ProtectedRoute><UpdateCandidate /></ProtectedRoute>} />
                <Route path="/employee/user-candidates" element={<ProtectedRoute><UserCandidatelist /></ProtectedRoute>} />

                <Route path="/employee/submitted-profiles" element={<ProtectedRoute><SubmittedProfiles /></ProtectedRoute>} />

                <Route path="/employee/vendors" element={<ProtectedRoute><VendorManagement /></ProtectedRoute>} />
                <Route path="/employee/user-vendors" element={<ProtectedRoute><UserVendorManagement /></ProtectedRoute>} />
                <Route path="/employee/pool" element={<ProtectedRoute><PoolSelect /></ProtectedRoute>} />

                <Route path="/employee/vendor/view/:id" element={<ProtectedRoute><VendorView /></ProtectedRoute>} />
                <Route path="/employee/vendor/doc-view/:id" element={<ProtectedRoute><DocViewer /></ProtectedRoute>} />
                <Route path="/employee/vendor/add" element={<ProtectedRoute><AddVendor /></ProtectedRoute>} />
                <Route path="/employee/vendor/edit/:id" element={<ProtectedRoute><EditVendor /></ProtectedRoute>} />

                <Route path="/employee/clients" element={<ProtectedRoute><ClientList /></ProtectedRoute>} />
                <Route path="/employee/client/add" element={<ProtectedRoute><AddClient /></ProtectedRoute>} />
                <Route path="/employee/client/view/:id" element={<ProtectedRoute><EmployeeViewClient /></ProtectedRoute>} />
                <Route path="/employee/client/update/:id" element={<ProtectedRoute><UpdateClient /></ProtectedRoute>} />
                {/* ================================================ */}
                {/* ===== ATTENDANCE MODULE ===== */}
                <Route path="/employee/attendance"         element={<ProtectedRoute><AttendanceDashboard /></ProtectedRoute>} />
                <Route path="/employee/attendance/board"   element={<ProtectedRoute><AttendanceBoard /></ProtectedRoute>} />
                <Route path="/employee/attendance/monthly" element={<ProtectedRoute><MyMonthly /></ProtectedRoute>} />
                {/* ================================================ */}

                {/* =========Requiremens Route ======== */}
                <Route path="/employee/requirements" element={<ProtectedRoute><RequirementList /></ProtectedRoute>} />
                <Route path="/employee/requirement/create" element={<ProtectedRoute><RequirementCreate /></ProtectedRoute>} />
                <Route path="/employee/requirement/edit/:id" element={<ProtectedRoute><RequirementUpdate /></ProtectedRoute>} />

                <Route path="/employee/requirement/view/:id" element={<ProtectedRoute><RequirementView /></ProtectedRoute>} />
                <Route path="/employee/requirements/my" element={<ProtectedRoute><EmpMyRequirements /></ProtectedRoute>} />
                {/* sub-admin */}
                <Route path="/sub-admin/requirements" element={<ProtectedRoute><SubAdminRequirementList /></ProtectedRoute>} />
                <Route path="/sub-admin/requirement/create" element={<ProtectedRoute><SubAdminRequirementCreate /></ProtectedRoute>} />
                <Route path="/sub-admin/requirement/edit/:id" element={<ProtectedRoute><SubAdminRequirementUpdate /></ProtectedRoute>} />
                <Route path="/sub-admin/requirement/view/:id" element={<ProtectedRoute><SubAdminRequirementView /></ProtectedRoute>} /> 
                <Route path="/sub-admin/requirements/my" element={<ProtectedRoute><SubAdminMyRequirements /></ProtectedRoute>} />
                {/* ======================SUB-ADMIN========================================= */}
                <Route path="/sub-admin" element={<ProtectedRoute ><SubAdminDashboard /></ProtectedRoute>} />
                <Route path="/sub-admin/all-candidates" element={<ProtectedRoute><AllCandidateList /></ProtectedRoute>} />
                <Route path="/sub-admin/all-Vendors" element={<ProtectedRoute><AllVendorList /></ProtectedRoute>} />
                <Route path="/sub-admin/add-vendor" element={<ProtectedRoute><SubAdminAddVendor /></ProtectedRoute>} />
                <Route path="/sub-admin/edit-vendor/:id" element={<ProtectedRoute><EditVendorSubAdmin /></ProtectedRoute>} />
                <Route path="/sub-admin/add-candidate" element={<ProtectedRoute><SubAdminAddCandidate /></ProtectedRoute>} />
                <Route path="/sub-admin/candidate/view/:id" element={<ProtectedRoute><SubAdminViewCandidate /></ProtectedRoute>} />
                <Route path="/sub-admin/candidate/edit/:id" element={<ProtectedRoute><SubAdminEditCandidate /></ProtectedRoute>} />
                <Route path="/sub-admin/vendor/view/:id" element={<ProtectedRoute><VendorViewSubAdmin /></ProtectedRoute>} />
                <Route path="/sub-admin/clients" element={<ProtectedRoute><SubAdminClientList /></ProtectedRoute>} />
                <Route path="/sub-admin/client/edit/:id" element={<ProtectedRoute><SubadminUpdateClient /></ProtectedRoute>} />
                <Route path="/sub-admin/client/add" element={<ProtectedRoute><SubAdminAddClient /></ProtectedRoute>} />
                <Route path="/sub-admin/vendor/doc-view/:id" element={<ProtectedRoute><SubAdminDocView /></ProtectedRoute>} />
                <Route path="/sub-admin/team-manage" element={<ProtectedRoute><SubAdminTeamManage /></ProtectedRoute>} />
                <Route path="/sub-admin/add-user" element={<ProtectedRoute><AddUser /></ProtectedRoute>} />
                <Route path="/sub-admin/user/detail/:id" element={<ProtectedRoute><SubAdminUserDetail /></ProtectedRoute>} />
                <Route path="/sub-admin/user/update/:id" element={<ProtectedRoute><SubAdminUserUpdate /></ProtectedRoute>} />

                <Route path="/sub-admin/client/view/:id" element={<ProtectedRoute><SubAdminClientView /></ProtectedRoute>} />
                <Route path="/sub-admin/total-submitted-profiles" element={<ProtectedRoute><SubadminTotalSubmittedProfiles /></ProtectedRoute>} />

                <Route path="/sub-admin/total-onbording" element={<ProtectedRoute><SubadminTotalOnbording /></ProtectedRoute>} />
                <Route path="/sub-admin/todays-submitted-profiles" element={<ProtectedRoute><SubadminTodaysSubmittedProfiles /></ProtectedRoute>} />

                <Route path="/sub-admin/todays-New-Profiles" element={<ProtectedRoute><SubadminTodaysNewProfiles /></ProtectedRoute>} />

                <Route path="/sub-admin/Pipeline" element={<ProtectedRoute><SubadminPipeline /></ProtectedRoute>} />

                <Route path="/sub-admin/offboarded-profiles" element={<ProtectedRoute><OffboardedProfiles /></ProtectedRoute>} />
                
                <Route path="/sub-admin/create-invoice" element={<ProtectedRoute><SubadminCreateInvoice /></ProtectedRoute>} />

                <Route path="/sub-admin/invoice/preview/:invoice_id" element={<ProtectedRoute><SubadminInvoicePreview /></ProtectedRoute>} />

                <Route path="/sub-admin/invoices" element={<ProtectedRoute><SubadminInvoices /></ProtectedRoute>} />

                <Route path="/sub-admin/invoice/settings" element={<ProtectedRoute><SubadminSettings /></ProtectedRoute>} />
                <Route path="/sub-admin/invoice/settings/edit" element={<ProtectedRoute><SubadminSettingsEdit /></ProtectedRoute>} />
                <Route path="/sub-admin/invoice/edit/:id" element={<ProtectedRoute><SubadminEditInvoice /></ProtectedRoute>} />
                
                <Route path="/sub-admin/invoice/candidate-history/:candidateId" element={<ProtectedRoute><CandidateInvoiceHistory /></ProtectedRoute>} />

                {/* ======================================================================== */}
                {/* ================================Accounts Dashbaord Routes======================================== */}

                <Route path="/accounts" element={<ProtectedRoute><AccountsDashboard /></ProtectedRoute>} />
                <Route path="/accounts/settings" element={<ProtectedRoute><FinanceSettings /></ProtectedRoute>} />
                <Route path="/accounts/finance-overview" element={<ProtectedRoute><FinanceList /></ProtectedRoute>} />
                <Route path="/accounts/create-invoice" element={<ProtectedRoute><CreateInvoice /></ProtectedRoute>} />
                <Route path="/accounts/all-invoices" element={<ProtectedRoute><AllInvoices /></ProtectedRoute>} />
                <Route path="/accounts/invoice/edit/:id" element={<ProtectedRoute><EditInvoice /></ProtectedRoute>} />

                {/* ================================================================================================= */}

                {/* =================================Attendance - admin ================================================================ */}
                <Route path="/sub-admin/team-reports" element={<ProtectedRoute><TeamReports /></ProtectedRoute>} />
                {/* ================================================================================================= */}

                <Route path="/central-admin" element={<ProtectedRoute><CentralAdminDashboard /></ProtectedRoute>} />

            </Routes>
        </BrowserRouter>
    );
}

export default App;










// import { BrowserRouter, Routes, Route } from "react-router-dom";

// import Login from "./pages/Login";
// import Register from "./pages/Register";
// import SubAdminDashboard from "./pages/sub_admin/SubAdminDashboard";
// import CentralAdminDashboard from "./pages/central_admin/CentralAdminDashboard";
// import EmployeeDashboard from "./pages/emplyee_portal/EmployeeDashboard";

// // #===================Vendor=========================
// import UserVendorManagement from "./pages/emplyee_portal/UserVendorManagement";
// import AddVendor from "./pages/emplyee_portal/AddVendor";
// import VendorView from "./pages/emplyee_portal/VendorView";
// import DocViewer from "./pages/emplyee_portal/DocViewer";
// import EditVendor from "./pages/emplyee_portal/EditVendor";
// // ====================Client==========================
// import ClientList from "./pages/emplyee_portal/ClientList";
// import AddClient from "./pages/emplyee_portal/AddClient";
// // ====================candidate================================
// import AddCandidate from "./pages/emplyee_portal/AddCandidate";
// import CandidateList from "./pages/emplyee_portal/CandidateList";
// import ViewCandidate from "./pages/emplyee_portal/ViewCandidate";
// import UpdateCandidate from "./pages/emplyee_portal/UpdateCandidate";
// import UserCandidatelist from "./pages/emplyee_portal/UserCandidateList";
// // ====================Pool=========================================
// import PoolSelect from "./pages/emplyee_portal/Pool";
// import VendorManagement from "./pages/emplyee_portal/VendorManagement";

// function App() {
//     return ( <
//         BrowserRouter >
//         <
//         Routes > { /* Auth */ } <
//         Route path = "/"
//         element = { < Login / > }
//         /> <
//         Route path = "/register"
//         element = { < Register / > }
//         />

//         { /* Employee */ } <
//         Route path = "/employee"
//         element = { < EmployeeDashboard / > }
//         />  
//         // ========================================Candidate===================================================
//         <
//         Route path = "/employee/candidates/add"
//         element = { < AddCandidate / > }
//         />

//         <
//         Route path = "/employee/candidates"
//         element = { < CandidateList / > }
//         />

//         <
//         Route path = "/employee/candidate/view/:id"
//         element = { < ViewCandidate / > }
//         />
        
//         <
//         Route path = "/employee/candidate/edit/:id"
//         element = { < UpdateCandidate / > }
//         />

//          <
//         Route path = "/employee/user-candidates"
//         element = { < UserCandidatelist / > }
//         />

//         // ===========================================================================================
//         <Route path = "/employee/vendors" element = { < VendorManagement / > }/ >
//         <Route path = "/employee/user-vendors" element = { < UserVendorManagement / > }/ >

//         <
//         Route path = "/employee/pool"
//         element = { < PoolSelect / > }
//         / >

//         <
//         Route path = "/employee/vendor/view/:id"
//         element = { < VendorView / > }
//         / >

//         <
//         Route path = "/employee/vendor/doc-view/:id"
//         element = { < DocViewer / > }
//         />

//         <
//         Route path = "/employee/vendor/add/"
//         element = { < AddVendor / > }
//         / >

//         <
//         Route path = "/employee/vendor/edit/:id"
//         element = { < EditVendor / > }
//         />

//         <
//         Route path = "/employee/clients"
//         element = { < ClientList / > }
//         /> <
//         Route path = "/employee/client/add"
//         element = { < AddClient / > }
//         />

//         { /* Sub Admin */ } <
//         Route path = "/sub-admin"
//         element = { < SubAdminDashboard / > }
//         />

//         { /* Central Admin */ } <
//         Route path = "/central-admin"
//         element = { < CentralAdminDashboard / > }
//         /> < /
//         Routes > <
//         /BrowserRouter>
//     );
// }

// export default App;